export const StandardLanguageMapper: { [key: string]: string } = {
  no: "nb-NO",
  en: "en-US",
  sv: "sv-SE",
  da: "da-DK",
  fi: "fi-FI",
  de: "de-DE",
  fr: "fr-FR",
  es: "es-ES",
  it: "it-IT",
  pt: "pt-PT",
};
